<template>
<!--    <div ref="contentDiv" class="sub_section" contenteditable="true" v-html="form.html"></div>-->
    <div>
        <editor api-key="6fcut3p0963eupgz9i3rukd5fx5p6oj5teregn2fhr9w2r6l" v-model="form.html"></editor>
    </div>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import {onMounted, ref} from "vue";
import Editor from '@tinymce/tinymce-vue'

export default {
    name: "EditBlockContent",
    components: {
        Editor
    },
    props: {
        client: {
            type: Object,
            required: true,
        },
        quote: {
            type: Object,
            required: true,
        },
        element: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        /* Unused component. It renders an editor in a separate route. Left here for possible future use */
        const form = useForm({
            html: props.element.html ?? '',
        });

        const contentDiv = ref(null);

        onMounted(() => {
            window.onmessage = function(e) {
                if (e.data === 'save') {
                    form.put(
                        route('admin.quote.block.content.save', {
                            client: props.client.id,
                            quote: props.quote.id,
                            blockUuid: props.element.uuid
                        }), {
                            onSuccess: () => {
                                //window.top.postMessage('saved', '*')
                            }
                        });
                }
            };
        });

        return {
            form,
            contentDiv
        };
    }
}
</script>
